import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModifyParams, TaskHumanOverwrite, TaskHumanOverwriteOne } from '@app/interfaces/lm/task-human';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TaskHumanService {
    private baseUrl = environment.api.services.lm + '/task/resource/human';

    constructor(private http: HttpClient) {
    }

    async find(params: {task: string}): Promise<any> {
        return lastValueFrom(this.http.get(`${this.baseUrl}/list`, {
            params: Object.assign(params)
        }));
    }

    async overwrite(params: TaskHumanOverwrite): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/overwrite`, params));
    }

    async overwriteOne(params: TaskHumanOverwriteOne): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/overwrite/one`, params));
    }

    async modify(params: ModifyParams): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/modify`, params));
    }
}
